module.exports = __webpack_public_path__ + "static/media/bajkal.d845426f.jpg";